<template>
    <div class="invitation-page">
        <v-container class="text-xs-center invitation-wrapper">
            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-form
                            v-on:submit.prevent="validate()"
                            ref="form"
                    >
                        <v-card-title>
                            <span class="headline">{{$t('add_new_employee')}}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <div class="flex">
                                    <v-text-field
                                            autofocus
                                            v-model="celular_nuevo"
                                            prepend-icon="phone_iphone"
                                            name="celular_nuevo"
                                            :label="$t('celular')"
                                            counter="10"
                                            maxlength="10"
                                            :rules="[rules.required, rules.counter, rules.number]"
                                    >
                                    </v-text-field>
                                </div>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="dialog = false"
                            >{{$t('cerrar')}}</v-btn>
                            <v-btn
                                    color="primary"
                                    @click="validate()"
                            >{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="dialog_bloqueo"
                    persistent
                    width="500"
            >
                <v-card class="elevation-0">
                    <v-toolbar class="mb-0" dark color="warning">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout align-center justify-center>
                            <h2>{{$t('pagina_caduca')}}</h2>
                            <v-btn
                                    color="primary"
                                    large
                                    to="/home"
                            >
                                <v-icon left>home</v-icon>
                                {{$t('inicio')}}
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="dialog_sin_permisos"
                    persistent
                    width="500"
            >
                <v-card class="elevation-0">
                    <v-toolbar class="mb-0" dark color="warning">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout align-center justify-center>
                            <h2>{{$t('sin_permisos')}}</h2>
                            <v-btn
                                    color="primary"
                                    large
                                    to="/home"
                            >
                                <v-icon left>home</v-icon>
                                {{$t('inicio')}}
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-layout row wrap>
                <v-flex md12>
                    <v-card class="elevation-2 invitation-card">
                        <v-toolbar class="mb-1" dark color="primary">
                            <v-toolbar-title>
                                Datos de la Invitación
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>

                        <!-- Hero: logo + info empresa -->
                        <v-card-text class="pb-0">
                            <v-layout row wrap align-center class="company-hero">
                                <v-flex xs12 sm4 class="company-hero-logo-col">
                                    <div class="company-logo-frame">
                                        <v-img
                                            v-if="info.logoCompany"
                                            class="centrado"
                                            :src="info.logoCompany"
                                            height="140"
                                            contain
                                        ></v-img>
                                        <div v-else class="logo-fallback d-flex align-center justify-center">
                                            <v-icon color="primary" size="52">business</v-icon>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm8 class="company-hero-info-col">
                                    <div class="display-hero-title primary--text">{{ info.companyName || 'Empresa anfitriona' }}</div>
                                    <div class="subheading grey--text text--darken-1 mb-3">Invitación empresarial</div>
                                    <div>
                                        <v-chip small color="primary" text-color="white" class="mr-2">
                                            <v-icon left small>group</v-icon>
                                            Invitados: {{ id_empleado ? id_empleado.length : 0 }}
                                        </v-chip>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>

                        <v-card-text>
                            <v-form
                                    class="mb-4"
                                    @submit.prevent="create_invt_empresarial()">

                                <!-- SECCIÓN: Detalles de la invitación -->
                                <v-subheader class="primary--text font-weight-bold pl-0">
                                    <v-icon small class="mr-2" color="primary">event_note</v-icon>
                                    Detalles de la invitación
                                </v-subheader>
                                <v-divider class="mb-2"></v-divider>
                                <table class="inv-details-table">
                                    <tbody>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">business</v-icon>
                                                {{ $t('lbl_host_company') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info.companyName }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">person</v-icon>
                                                {{ $t('Anfitrion') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info.hostName }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">today</v-icon>
                                                {{ $t('fecha_hora') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info.dateInv }} {{ info.timeInv }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">subject</v-icon>
                                                {{ $t('Asunto') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info.subject }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">room</v-icon>
                                                {{ $t('Area') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info.areaName }}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- SECCIÓN: Datos adicionales -->
                                <v-subheader class="primary--text font-weight-bold pl-0 mt-3">
                                    <v-icon small class="mr-2" color="primary">edit</v-icon>
                                    Datos adicionales
                                </v-subheader>
                                <v-divider class="mb-3"></v-divider>

                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <div class="body-2 mb-1">
                                            <v-icon small color="primary" class="mr-1">directions_car</v-icon>
                                            {{ $t('mensaje_vehiculo') }}
                                        </div>
                                        <v-radio-group
                                            v-model="vehicle"
                                            name="vehicle"
                                            :mandatory="false"
                                            :error-messages="errores.vehicle"
                                            row
                                        >
                                            <v-radio :label="$t('Si')" value=true></v-radio>
                                            <v-radio label="No" value=false></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-textarea
                                            v-model="notes"
                                            prepend-icon="notes"
                                            name="notes"
                                            :label="$t('Notas')"
                                            :placeholder="$t('placeholder_notas')"
                                            :error-messages="errores.notes"
                                            rows="2"
                                            auto-grow
                                            outline
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>

                                <!-- SECCIÓN: Empleados invitados -->
                                <v-subheader class="primary--text font-weight-bold pl-0 mt-3">
                                    <v-icon small class="mr-2" color="primary">group</v-icon>
                                    {{ $t('Empleados') }}
                                </v-subheader>
                                <v-divider class="mb-3"></v-divider>

                                <v-autocomplete
                                    v-model="id_empleado"
                                    prepend-icon="person"
                                    name="id_empleado"
                                    :item-text="example"
                                    item-value="id"
                                    :label="$t('Empleado')"
                                    :filter="customFilter"
                                    :error-messages="errores.guest"
                                    :items="empleados"
                                    :no-data-text="$t('no_resultados')"
                                    clearable
                                    chips
                                    multiple
                                    return-object
                                ></v-autocomplete>

                                <v-divider class="mb-3 mt-2"></v-divider>
                                <v-layout justify-end>
                                    <v-btn
                                        color="primary"
                                        :loading="loading_send"
                                        @click="create_invt_empresarial()"
                                    >
                                        <v-icon left>send</v-icon>
                                        {{$t('enviar')}}
                                    </v-btn>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import {mapGetters, mapState} from 'vuex'

    Vue.use(VeeValidate)

    export default {
        name: "form_tercero",
        data () {
            return {
                rules: {
                    required: value => !!value || 'Campo Requerido',
                    counter: value => value.length >= 10 || 'El Número de Celular debe de contener 10 dígitos',
                    number: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Ingresa un Campo Númerico.'
                    },
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Dirección E-Mail no Válida.'
                    },
                },
                info: '',
                vehicle: '',
                notes: '',
                cellphone: '',
                email: '',
                errores: [],
                dialog_bloqueo: false,
                dialog_sin_permisos: false,
                dialog: false,
                celular_nuevo: '',
                entries: [],
                isLoading: false,
                search: null,
                loading_send: false,
                today: '',
                empleados: [],
                id_empleado: null,
            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['language']),
            fields () {
                if (!this.email) return []

                return Object.keys(this.email).map(key => {
                    return {
                        key,
                        value: this.email[key] || 'n/a'
                    }
                })
            },
            items () {
                return this.entries.map(entry => {
                    const email = entry.email.length > this.descriptionLimit
                        ? entry.email.slice(0, this.descriptionLimit) + '...'
                        : entry.email

                    return Object.assign({}, entry, { email })
                })
            }
        },
        watch: {
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            search (val) {
                // Items have already been loaded
                //if (this.items.length > 0) return

                // Items have already been requested
                //if (this.isLoading) return
                if (val.length > 2){

                    this.isLoading = true

                    // Lazily load input items
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/empresas/empleados/filter?search=' + val,
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            console.log(response.data)
                            if(this.entries.length > 0){
                                for(var i =0 ; i < response.data.length; i++){
                                    this.entries.push(response.data[i])
                                }
                            }
                            else
                                this.entries = response.data
                        })
                        .catch(error => {
                            console.log(error)
                        })
                        .finally(() => (this.isLoading = false))
                }
            }
        },
        created: function(){
            this.get_info_invit_empresarial()
            this.getEmpleados()
        },
        methods:{
            example: item => item.id_usuario.first_name + ' ' + item.id_usuario.last_name +' - ' + item.id_usuario.email,
            customFilter (item, queryText) {
                const textOne = item.id_usuario.first_name.toLowerCase()
                const textTwo = item.id_usuario.last_name.toLowerCase()
                const textThree = item.id_usuario.email.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
                    || textTwo.indexOf(searchText) > -1
                    || textThree.indexOf(searchText) > -1
            },
            getEmpleados () {
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/empresas/empleados/',
                headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.empleados = response.data
                    console.log(this.empleados)
                })
                .catch(error => {
                    console.log(error)
                })
            },
            validate () {
                if (this.$refs.form.validate()) {
                    this.dialog = false
                    this.add_new_employee()
                }
            },
            add_new_employee(){
                this.entries.push(
                    {
                        "email": '',
                        "celular": this.celular_nuevo
                    }
                )
                this.email.push(
                    {
                        "email": '',
                        "celular": this.celular_nuevo
                    }
                )
            },
            get_info_invit_empresarial(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getReferralInv/' + this.$route.params['token'] + '/',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                axios(config)
                    .then(response => {
                        this.info = response.data
                        if(response.data.length === 0){
                            this.dialog_bloqueo = true
                            console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_current_date(){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd
                }

                if(mm<10)
                {
                    mm='0'+mm
                }
                this.today = yyyy + '-' + mm + '-' + dd
            },
            create_invt_empresarial(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading_send = true
                        this.errores = []
                        this.get_current_date()
                        console.log('this.id_empleado = ', this.id_empleado)
                        var guests = null
                        if (this.id_empleado !== null  && this.id_empleado !== undefined && this.id_empleado !== '' && this.id_empleado.length > 0) {
                            guests = []
                            for(let i = 0; i < this.id_empleado.length; i++) {
                              guests.push({
                                email: this.id_empleado[i].id_usuario.email,
                                cellphone: this.id_empleado[i].id_usuario.celular
                              })
                            }
                        }
                        // console.log('AUTOCOMPLETE = ', this.email)
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/createEnterpriseInv/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                expiration: this.info.dateInv.split("-").reverse().join("-"),
                                notes: this.notes,
                                companyFrom: this.info.companyName,
                                idReferredInv: this.info.id,
                                vehicle: this.vehicle,
                                guest: guests
                            }
                        };
                        axios(config)
                            .then(ok => {
                                console.log('Invitación Creada Correctamente.')
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
                                this.loading_send = false
                                this.$router.push({path: '/'})
                                // setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                                if(error.response.status == 403)
                                    this.dialog_sin_permisos = true
                                this.loading_send = false
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                    this.loading_send = false
                });
            },
            fullNamePlusCellphone: item => item.email + ' ' + item.celular + ' ' + item.first_name + ' ' + item.last_name
        }
    }
</script>

<style scoped>
    .invitation-page {
        background: linear-gradient(180deg, #f4f7fb 0%, #ffffff 100%);
        min-height: 100%;
    }

    .invitation-wrapper {
        max-width: 1150px;
    }

    .invitation-card {
        border-radius: 12px;
        overflow: hidden;
    }

    .company-hero {
        background: linear-gradient(135deg, rgba(0, 43, 72, 0.06) 0%, rgba(25, 118, 210, 0.08) 100%);
        border: 1px solid rgba(25, 118, 210, 0.15);
        border-radius: 12px;
        padding: 16px 20px;
    }

    .company-hero-logo-col {
        padding: 8px 16px 8px 8px;
    }

    .company-hero-info-col {
        padding: 8px 8px 8px 20px;
        border-left: 2px solid rgba(25, 118, 210, 0.18);
    }

    @media (max-width: 599px) {
        .company-hero-info-col {
            border-left: none;
            border-top: 2px solid rgba(25, 118, 210, 0.18);
            padding: 16px 8px 8px 8px;
            text-align: center;
        }
    }

    .display-hero-title {
        font-size: 1.35rem;
        font-weight: 700;
        line-height: 1.3;
        margin-bottom: 4px;
    }

    .company-logo-frame {
        background: #ffffff;
        border: 1px solid #e5edf5;
        border-radius: 10px;
        padding: 12px;
        min-height: 164px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .logo-fallback {
        min-height: 140px;
        width: 100%;
        background: #f7fbff;
        border-radius: 8px;
    }

    .inv-details-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 8px;
    }
    .inv-dt-label {
        width: 42%;
        padding: 7px 12px 7px 4px;
        vertical-align: middle;
        font-size: 0.82rem;
        color: #616161;
        white-space: nowrap;
    }
    .inv-dt-value {
        padding: 7px 4px;
        vertical-align: middle;
        font-size: 0.9rem;
        color: #212121;
        font-weight: 500;
    }
    .inv-details-table tbody tr:nth-child(even) {
        background: rgba(25, 118, 210, 0.04);
    }

    .centrado {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
</style>
